import Vue from 'vue';

import VueToast from 'vue-toast-notification';

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';

import money from 'v-money';

import VueMask from 'v-mask';
import Paginate from 'vuejs-paginate';

import 'vuetify/dist/vuetify.min.css';
import 'vue-toast-notification/dist/theme-default.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'font-awesome/css/font-awesome.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'jquery/dist/jquery';
import '@popperjs/core/dist/umd/popper';
import 'bootstrap/dist/js/bootstrap';
import 'material-icons/iconfont/material-icons.css';

import VuejsDialog from 'vuejs-dialog';

import 'vuejs-dialog/dist/vuejs-dialog.min.css';

import Vuetify from 'vuetify';

import './global/styles.css';
import './global/buttons.css';
import './global/text.css';
import './global/colors.css';

import Vuesax from 'vuesax';
import 'vuesax/dist/vuesax.css'

import * as VueGoogleMaps from 'vue2-google-maps';

Vue.component('paginate', Paginate);

Vue.use(Vuetify);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VuejsDialog);
Vue.use(VueToast);
Vue.use(VueMask);
Vue.use(money, {
    decimal: ",",
    thousands: ".",
    prefix: "",
    suffix: "",
    precision: 2,
    masked: false
});
Vue.use(Vuesax);
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCk9RFTZt3Qym7EKJbr_d3bDBxjq248Bwc',
        libraries: 'places',
    },
});

import App from './App.vue';

import router from './routes';

Vue.config.productionTip = false;

new Vue({ vuetify: new Vuetify(), render: h => h(App), router }).$mount('#app');
